/* Herend Set My Style — Park Shores Gifts
   Reads assets/herend-sms.json, draws the place setting to scale, lets the shopper pick a pattern per piece,
   keeps the setting in the URL, and adds every piece to the cart at once. */
(function () {
  'use strict';
  var root = document.querySelector('[data-herend-sms]');
  if (!root) return;

  var els = {
    layers: root.querySelector('[data-sms-layers]'),
    rail: root.querySelector('[data-sms-rail]'),
    count: root.querySelector('[data-sms-count]'),
    total: root.querySelector('[data-sms-total]'),
    per: root.querySelector('[data-sms-per]'),
    qty: root.querySelector('[data-sms-qty-input]'),
    add: root.querySelector('[data-sms-add]'),
    share: root.querySelector('[data-sms-share]'),
    status: root.querySelector('[data-sms-status]'),
    picker: root.querySelector('[data-sms-picker]'),
    pickerTitle: root.querySelector('[data-sms-picker-title]'),
    pickerGrid: root.querySelector('[data-sms-picker-grid]'),
    pickerSearch: root.querySelector('[data-sms-picker-search]')
  };
  var addLabel = root.dataset.addLabel || 'Add [n] place setting[s] to cart';
  var tableEl = root.querySelector('[data-sms-table]');
  var flatwareEl = root.querySelector('[data-sms-flatware]');
  var geo = null; // the place setting laid out in inches (set in init, once the slots are known)
  var data = null, slots = [], patterns = {}, order = [];
  var state = { sel: {}, qty: 1, palette: [] };
  var pickingSlot = null;

  function money(n) { return '$' + n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }
  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function img(url, w) { if (!url) return ''; return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }
  function piece(handle, slot) { var p = patterns[handle]; return p && p.pieces[slot] ? p.pieces[slot] : null; }
  function shortName(h) {
    var p = patterns[h]; if (!p) return '';
    if (p.colorway && p.name.length > p.colorway.length && p.name.slice(-p.colorway.length) === p.colorway) return p.name.slice(0, -p.colorway.length).trim();
    return p.family || p.name;
  }
  var view = 'pictures';
  try { view = localStorage.getItem('herend-sms-view') === 'names' ? 'names' : 'pictures'; } catch (e) {}

  /* ---- state <-> url ---- */
  function readUrl() {
    var q = new URLSearchParams(location.search);
    var set = q.get('set'); var out = { sel: {}, qty: parseInt(q.get('qty'), 10) || 1, pattern: q.get('pattern') };
    if (set) set.split(',').forEach(function (pair) { var i = pair.indexOf(':'); if (i > 0) out.sel[pair.slice(0, i)] = pair.slice(i + 1); });
    return out;
  }
  function persist() {
    try { localStorage.setItem('herend-sms', JSON.stringify({ sel: state.sel, qty: state.qty, savedAt: Date.now() })); } catch (e) { /* storage unavailable */ }
  }
  function restore() {
    try { var raw = localStorage.getItem('herend-sms'); return raw ? JSON.parse(raw) : null; } catch (e) { return null; }
  }
  function writeUrl() {
    persist();
    var parts = [];
    slots.forEach(function (s) { var c = state.sel[s.slot]; if (c && c.on && c.pattern) parts.push(s.slot + ':' + c.pattern); });
    var q = new URLSearchParams(location.search);
    q.delete('set'); q.delete('qty'); q.delete('pattern');
    if (parts.length) q.set('set', parts.join(','));
    if (state.qty > 1) q.set('qty', String(state.qty));
    var url = location.pathname + (q.toString() ? '?' + q.toString() : '');
    history.replaceState(null, '', url);
    return location.origin + url;
  }

  /* ---- init ---- */
  function init() {
    slots = data.slots; order = data.patterns.map(function (p) { return p.handle; });
    geo = buildGeometry();
    tableEl.style.aspectRatio = geo.w + ' / ' + geo.h;
    if (flatwareEl) { flatwareEl.setAttribute('viewBox', geo.x0 + ' ' + geo.y0 + ' ' + geo.w + ' ' + geo.h); flatwareEl.innerHTML = flatwareSvg(); }
    data.patterns.forEach(function (p) { patterns[p.handle] = p; });
    var u = readUrl();
    if (!u.pattern && !Object.keys(u.sel).length) {
      var saved = restore();
      if (saved && saved.sel) { Object.keys(saved.sel).forEach(function (k) { if (saved.sel[k] && saved.sel[k].on && patterns[saved.sel[k].pattern]) u.sel[k] = saved.sel[k].pattern; }); if (saved.qty) u.qty = saved.qty; }
    }
    var base = u.pattern || root.dataset.defaultPattern;
    if (!patterns[base]) {
      // a collection link for a colour-split line (?pattern=herend-silk-ribbon) opens its first colour
      var sub = base ? order.filter(function (h) { return h.indexOf(base + '-') === 0; })[0] : null;
      base = sub || order[0];
    }
    var defaults = (root.dataset.defaultSlots || '').split(',').map(function (s) { return s.trim(); });
    slots.forEach(function (s) {
      // a saved or shared choice only counts if that pattern still makes this piece
      var fromUrl = u.sel[s.slot] && piece(u.sel[s.slot], s.slot) ? u.sel[s.slot] : null;
      var on = fromUrl ? true : (Object.keys(u.sel).length ? false : (defaults.length && defaults[0] ? defaults.indexOf(s.slot) > -1 : s.default) && !!piece(base, s.slot));
      var pat = fromUrl || (piece(base, s.slot) ? base : firstWith(s.slot));
      state.sel[s.slot] = { on: on && !!pat, pattern: pat };
    });
    state.qty = Math.min(24, Math.max(1, u.qty));
    els.qty.value = state.qty;
    rebuildPalette();
    render();
  }
  /* ---- geometry: everything in inches, origin at the centre of the plate stack, y down ----
     Fork left of the charger, knife and teaspoon right of it, bottoms level just above the plate's bottom edge;
     bread & butter plate above the forks; cup & saucer to the right of the spoon. The table box is fitted to
     that with a small margin, so the pieces scale with the box width on every screen. */
  var FORK = { len: 7.5, w: 1.0 }, KNIFE = { len: 9.5, w: 0.85 }, SPOON = { len: 6, w: 1.2 };
  var GAP = 0.5, MARGIN = 0.6;
  function buildGeometry() {
    var R = 0; slots.forEach(function (s) { if (s.pos === 'stack') R = Math.max(R, s.inches / 2); });
    var left = slots.filter(function (s) { return s.pos === 'left'; })[0], right = slots.filter(function (s) { return s.pos === 'right'; })[0];
    var rL = left ? left.inches / 2 : 0, rR = right ? right.inches / 2 : 0;
    var g = { R: R, bottom: R - 0.5 };
    g.fork = { x: -(R + GAP + FORK.w / 2) };
    g.knife = { x: R + GAP + KNIFE.w / 2 };
    g.spoon = { x: g.knife.x + KNIFE.w / 2 + 0.3 + SPOON.w / 2 };
    g.left = { x: g.fork.x - 0.75, y: (g.bottom - FORK.len) - 0.4 - rL };    // bread & butter plate, a touch left of the fork so it clears the charger
    g.right = { x: g.spoon.x + SPOON.w / 2 + 0.6 + rR, y: -1 };              // cup & saucer
    g.x0 = (left ? g.left.x - rL : g.fork.x - FORK.w / 2) - MARGIN;
    g.x1 = (right ? g.right.x + rR : g.spoon.x + SPOON.w / 2) + MARGIN;
    g.y0 = Math.min(left ? g.left.y - rL : 0, right ? g.right.y - rR : 0, -R, g.bottom - KNIFE.len) - MARGIN;
    g.y1 = R + MARGIN;
    g.w = g.x1 - g.x0; g.h = g.y1 - g.y0;
    return g;
  }
  function flatwareSvg() {
    var f = geo.fork.x, k = geo.knife.x, sp = geo.spoon.x, yb = geo.bottom;
    var ft = yb - FORK.len, kt = yb - KNIFE.len, st = yb - SPOON.len, d = [];
    // fork: handle, four 2" tines, curved head (about 1" across)
    d.push('M' + f + ',' + yb + 'V' + (ft + 2.5));
    [-0.42, -0.14, 0.14, 0.42].forEach(function (dx) { d.push('M' + (f + dx) + ',' + ft + 'V' + (ft + 1.9)); });
    d.push('M' + (f - 0.42) + ',' + (ft + 1.9) + 'a0.42,0.6 0 0 0 0.84,0');
    // knife: spine and a 4" blade
    d.push('M' + k + ',' + (kt + 1) + 'V' + yb);
    d.push('M' + (k - 0.38) + ',' + (kt + 1) + 'a0.38,1 0 0 1 0.76,0v2.9a0.38,0.55 0 0 1 -0.76,0z');
    // teaspoon: 1.3" × 2" bowl and handle
    d.push('M' + sp + ',' + (st + 0.9) + 'V' + yb);
    d.push('M' + (sp - 0.55) + ',' + (st + 0.9) + 'a0.55,0.9 0 0 1 1.1,0v1.1a0.55,0.6 0 0 1 -1.1,0z');
    return '<path vector-effect="non-scaling-stroke" d="' + d.join('') + '"/>';
  }
  function firstWith(slot) { for (var i = 0; i < order.length; i++) if (piece(order[i], slot)) return order[i]; return null; }
  function rebuildPalette() {
    var seen = {};
    state.palette = [];
    slots.forEach(function (s) { var c = state.sel[s.slot]; if (c.on && c.pattern && !seen[c.pattern]) { seen[c.pattern] = 1; state.palette.push(c.pattern); } });
    if (!state.palette.length) { var b = firstWith('dinner-plate'); if (b) state.palette.push(b); }
  }

  /* ---- render ---- */
  function render() {
    renderTable(); renderRail(); renderTotals(); writeUrl();
  }
  function renderTable() {
    var html = '';
    var stack = slots.filter(function (s) { return s.pos === 'stack'; });
    // largest first so the stack layers correctly
    var withSize = stack.map(function (s) { var c = state.sel[s.slot]; var p = c.on ? piece(c.pattern, s.slot) : null; return { s: s, p: p, inches: p ? p.inches : s.inches }; });
    withSize.sort(function (a, b) { return b.inches - a.inches; });
    var anyStack = withSize.some(function (x) { return x.p; });
    withSize.forEach(function (x) { if (x.p || !anyStack) html += layer(x.s, x.p, 0, 0, x.inches); });
    slots.filter(function (s) { return s.pos === 'left'; }).forEach(function (s) { var c = state.sel[s.slot]; html += layer(s, c.on ? piece(c.pattern, s.slot) : null, geo.left.x, geo.left.y, s.inches); });
    slots.filter(function (s) { return s.pos === 'right'; }).forEach(function (s) { var c = state.sel[s.slot]; html += layer(s, c.on ? piece(c.pattern, s.slot) : null, geo.right.x, geo.right.y, s.inches); });
    els.layers.innerHTML = html;
  }
  function layer(s, p, cx, cy, inches) {
    // cx, cy, inches are real inches; the box is geo.w × geo.h inches, so width is a share of the box width
    // and top a share of its height (the slot keeps a 1:1 aspect ratio, so its height matches)
    var pct = (inches / geo.w) * 100;
    var style = 'width:' + pct + '%;left:' + ((cx - inches / 2 - geo.x0) / geo.w * 100) + '%;top:' + ((cy - inches / 2 - geo.y0) / geo.h * 100) + '%;';
    if (!p) return '<span class="herend-sms__slot herend-sms__slot--empty" style="' + style + '" aria-hidden="true"></span>';
    var name = patterns[state.sel[s.slot].pattern].name;
    // the table is the page's main content: load its few images eagerly (lazy loading held them back until the tab was focused)
    if (p.png) return '<span class="herend-sms__slot" style="' + style + '"><img src="' + esc(img(p.png, 800)) + '" alt="' + esc(name + ' ' + s.label) + '" loading="eager" decoding="async"></span>';
    // product photo shot straight down on white: multiply-blended so the white drops onto the cloth
    if (p.photo) return '<span class="herend-sms__slot herend-sms__slot--photo" style="' + style + '"><img src="' + esc(img(p.photo, 800)) + '" alt="' + esc(name + ' ' + s.label) + '" loading="eager" decoding="async"></span>';
    return '<span class="herend-sms__slot herend-sms__slot--plain" style="' + style + '"><span class="herend-sms__slot-name">' + esc(name) + '<br><small>' + esc(s.label) + '</small></span></span>';
  }
  var railBuilt = false;
  function renderRail() {
    var scroll = {};
    els.rail.querySelectorAll('[data-sms-strip]').forEach(function (el) { scroll[el.dataset.smsStrip] = el.scrollLeft; });
    var html = '';
    slots.forEach(function (s) {
      var c = state.sel[s.slot]; var p = c.pattern ? piece(c.pattern, s.slot) : null;
      var price = c.on && p ? money(p.price) : '—';
      // every pattern made in this piece, pictured ones first, then by name. The order never changes on
      // selection, so a pick doesn't shuffle the strip under the shopper's finger.
      var avail = order.filter(function (h) { return !!piece(h, s.slot); });
      avail.sort(function (a, b) {
        var pa = piece(a, s.slot).png || piece(a, s.slot).photo ? 0 : 1, pb = piece(b, s.slot).png || piece(b, s.slot).photo ? 0 : 1;
        return pa - pb || patterns[a].name.localeCompare(patterns[b].name);
      });
      html += '<div class="herend-sms__row' + (c.on ? ' is-on' : '') + '" data-slot="' + s.slot + '">'
        + '<div class="herend-sms__row-head">'
        + '<button type="button" class="herend-sms__tick" data-sms-toggle="' + s.slot + '" role="checkbox" aria-checked="' + (c.on ? 'true' : 'false') + '" aria-label="' + esc(s.label) + '">'
        + '<svg width="12" height="10" viewBox="0 0 12 10" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M1 5l3.5 3.5L11 1.5"/></svg></button>'
        + '<span class="herend-sms__row-name">' + esc(s.label) + ' <small>' + (p && p.inches ? p.inches + '″' : '') + '</small></span>'
        + '<span class="herend-sms__row-price">' + price + '</span></div>';
      html += '<div class="herend-sms__row-sub"><span class="herend-sms__row-pattern" data-sms-hint="' + s.slot + '">' + (c.on && c.pattern ? esc(patterns[c.pattern].name) : 'Choose a pattern') + '</span>'
        + '<span class="herend-sms__row-tools">'
        + '<button type="button" class="herend-sms__viewtoggle" data-sms-view aria-label="' + (view === 'pictures' ? 'Show names instead of pictures' : 'Show pictures') + '">' + (view === 'pictures' ? 'Names' : 'Pictures') + '</button>'
        + '<button type="button" class="herend-sms__seeall" data-sms-more="' + s.slot + '">See all ' + avail.length + '</button></span></div>';
      if (view === 'pictures') {
        html += '<div class="herend-sms__strip" data-sms-strip="' + s.slot + '">';
        // the chosen pattern is repeated as a sticky copy at the left edge, so the shopper always sees
        // what this row holds without hunting through the strip; tapping it scrolls to the original
        if (c.on && c.pattern && piece(c.pattern, s.slot)) {
          var ppc = piece(c.pattern, s.slot), pth = ppc.png || ppc.photo || patterns[c.pattern].thumb;
          html += '<span class="herend-sms__pin"><button type="button" class="herend-sms__thumb is-active" data-sms-pinned="' + s.slot + '" data-sms-thumb="' + esc(c.pattern) + '" data-sms-slot="' + s.slot + '" data-full="' + esc(patterns[c.pattern].name + ' · ' + money(ppc.price)) + '" aria-label="' + esc('Chosen: ' + patterns[c.pattern].name) + '">'
            + (pth ? '<img src="' + esc(img(pth, 160)) + '" alt="" width="64" height="64">' : '<span class="herend-sms__thumb-blank">' + esc(patterns[c.pattern].name.charAt(0)) + '</span>')
            + '</button></span>';
        }
        avail.forEach(function (h) {
          var pc = piece(h, s.slot); var on = c.on && c.pattern === h; var thumb = pc.png || pc.photo || patterns[h].thumb;
          html += '<button type="button" class="herend-sms__thumb' + (on ? ' is-active' : '') + '" data-sms-thumb="' + esc(h) + '" data-sms-slot="' + s.slot + '" data-short="' + esc(shortName(h)) + '" data-full="' + esc(patterns[h].name + ' · ' + money(pc.price)) + '" aria-label="' + esc(patterns[h].name) + '">'
            + (thumb ? '<img src="' + esc(img(thumb, 160)) + '" alt="" loading="lazy" width="64" height="64">' : '<span class="herend-sms__thumb-blank">' + esc(patterns[h].name.charAt(0)) + '</span>')
            + '</button>';
        });
        html += '</div>';
      } else {
        html += '<div class="herend-sms__strip herend-sms__strip--names" data-sms-strip="' + s.slot + '">';
        if (c.on && c.pattern && piece(c.pattern, s.slot)) {
          html += '<span class="herend-sms__pin"><button type="button" class="herend-chip herend-sms__chip is-active" data-sms-pinned="' + s.slot + '" data-sms-pick="' + esc(c.pattern) + '" data-sms-slot="' + s.slot + '" aria-label="' + esc('Chosen: ' + patterns[c.pattern].name) + '">' + esc(patterns[c.pattern].name) + '</button></span>';
        }
        avail.forEach(function (h) {
          var pc = piece(h, s.slot); var on = c.on && c.pattern === h;
          html += '<button type="button" class="herend-chip herend-sms__chip' + (on ? ' is-active' : '') + '" data-sms-pick="' + esc(h) + '" data-sms-slot="' + s.slot + '" title="' + esc(money(pc.price)) + '">' + esc(patterns[h].name) + '</button>';
        });
        html += '</div>';
      }
      if (c.on && p && p.items && p.items[0]) html += '<a class="herend-sms__row-link" href="/products/' + esc(p.items[0].handle) + '">' + (p.items.length > 1 ? 'Details' : esc(p.items[0].title)) + '</a>';
      html += '</div>';
    });
    els.rail.innerHTML = html;
    els.rail.querySelectorAll('[data-sms-strip]').forEach(function (el) {
      if (railBuilt) { el.scrollLeft = scroll[el.dataset.smsStrip] || 0; return; }
      // first paint: bring the pre-selected pattern into view without hiding what comes before it
      var on = el.querySelector('.is-active:not([data-sms-pinned])'); if (on) el.scrollLeft = Math.max(0, on.offsetLeft - el.clientWidth / 2 + on.offsetWidth / 2);
    });
    railBuilt = true;
  }
  function renderTotals() {
    var per = 0, count = 0;
    slots.forEach(function (s) { var c = state.sel[s.slot]; var p = c.on ? piece(c.pattern, s.slot) : null; if (p) { per += p.price; count += p.items.length; } });
    els.count.textContent = count + ' piece' + (count === 1 ? '' : 's');
    els.total.textContent = money(per * state.qty);
    els.per.textContent = money(per) + ' per setting × ' + state.qty;
    els.add.disabled = count === 0;
    els.add.textContent = addLabel.replace('[n]', state.qty).replace('[s]', state.qty === 1 ? '' : 's');
  }

  /* ---- picker ---- */
  function openPicker(slot) {
    pickingSlot = slot; var s = slots.filter(function (x) { return x.slot === slot; })[0];
    els.pickerTitle.textContent = s.label;
    els.pickerSearch.value = '';
    fillPicker('');
    els.picker.hidden = false; document.body.classList.add('herend-sms-picker-open');
    els.pickerSearch.focus();
  }
  function fillPicker(q) {
    q = q.toLowerCase();
    var html = '';
    order.forEach(function (h) {
      var p = patterns[h]; var pc = p.pieces[pickingSlot];
      if (!pc) return;
      if (q && (p.name + ' ' + p.family).toLowerCase().indexOf(q) === -1) return;
      var thumb = pc.png || pc.photo || p.thumb;
      html += '<button type="button" class="herend-sms__pat' + (state.sel[pickingSlot].pattern === h ? ' is-active' : '') + '" data-sms-pick="' + esc(h) + '" data-sms-slot="' + pickingSlot + '">'
        + '<span class="herend-sms__pat-media">' + (thumb ? '<img src="' + esc(img(thumb, 300)) + '" alt="" loading="lazy">' : '<span class="herend-sms__pat-blank">' + esc(p.name.charAt(0)) + '</span>') + '</span>'
        + '<span class="herend-sms__pat-name">' + esc(p.name) + '</span><span class="herend-sms__pat-price">' + money(pc.price) + (pc.png || pc.photo ? '' : ' · not pictured') + '</span></button>';
    });
    els.pickerGrid.innerHTML = html || '<p class="herend-sms__picker-empty">No pattern matches.</p>';
  }
  function closePicker() { els.picker.hidden = true; document.body.classList.remove('herend-sms-picker-open'); pickingSlot = null; }

  /* ---- events ---- */
  function hint(slot, text) {
    var el = els.rail.querySelector('[data-sms-hint="' + slot + '"]');
    if (!el) return;
    var c = state.sel[slot];
    el.textContent = text || (c.on && c.pattern ? patterns[c.pattern].name : 'Choose a pattern');
    el.classList.toggle('is-peek', !!text);
  }
  // Hovering a thumbnail shows its full name and price in the row; leaving the row restores the chosen name.
  els.rail.addEventListener('mouseover', function (e) {
    var t = e.target.closest('[data-sms-thumb]'); if (!t) return;
    hint(t.dataset.smsSlot, t.dataset.full);
  });
  els.rail.addEventListener('mouseout', function (e) {
    var row = e.target.closest('.herend-sms__row'); if (!row) return;
    if (e.relatedTarget && row.contains(e.relatedTarget) && e.relatedTarget.closest('[data-sms-thumb]')) return;
    hint(row.dataset.slot, '');
  });
  root.addEventListener('click', function (e) {
    var t = e.target.closest('[data-sms-toggle],[data-sms-pick],[data-sms-thumb],[data-sms-more],[data-sms-qty],[data-sms-picker-close],[data-sms-view]');
    if (!t) return;
    if (t.hasAttribute('data-sms-pinned')) {
      var strip = t.closest('[data-sms-strip]'), orig = strip && strip.querySelector('.is-active:not([data-sms-pinned])');
      if (orig) { try { orig.scrollIntoView({ inline: 'center', block: 'nearest', behavior: 'smooth' }); } catch (err) { orig.scrollIntoView(); } }
      return;
    }
    if (t.hasAttribute('data-sms-thumb')) {
      state.sel[t.dataset.smsSlot] = { on: true, pattern: t.dataset.smsThumb }; rebuildPalette(); render();
      return;
    }
    if (t.hasAttribute('data-sms-view')) {
      view = view === 'pictures' ? 'names' : 'pictures';
      try { localStorage.setItem('herend-sms-view', view); } catch (err) {}
      renderRail(); return;
    }
    if (t.hasAttribute('data-sms-toggle')) {
      var c = state.sel[t.dataset.smsToggle];
      if (!c.pattern) { openPicker(t.dataset.smsToggle); return; }
      c.on = !c.on; render();
    } else if (t.hasAttribute('data-sms-pick')) {
      var slot = t.dataset.smsSlot, h = t.dataset.smsPick;
      if (!piece(h, slot)) return;
      state.sel[slot] = { on: true, pattern: h };
      rebuildPalette(); closePicker(); render();
    } else if (t.hasAttribute('data-sms-more')) {
      openPicker(t.dataset.smsMore);
    } else if (t.hasAttribute('data-sms-qty')) {
      state.qty = Math.min(24, Math.max(1, state.qty + parseInt(t.dataset.smsQty, 10))); els.qty.value = state.qty; renderTotals(); writeUrl();
    } else if (t.hasAttribute('data-sms-picker-close')) {
      closePicker();
    }
  });
  els.qty.addEventListener('input', function () { state.qty = Math.min(24, Math.max(1, parseInt(els.qty.value, 10) || 1)); renderTotals(); writeUrl(); });
  els.pickerSearch.addEventListener('input', function () { fillPicker(els.pickerSearch.value); });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !els.picker.hidden) { closePicker(); return; }
    if ((e.key === 'Enter' || e.key === ' ') && e.target.hasAttribute && e.target.hasAttribute('data-sms-thumb')) {
      e.preventDefault(); var t = e.target; state.sel[t.dataset.smsSlot] = { on: true, pattern: t.dataset.smsThumb }; rebuildPalette(); render();
    }
  });

  els.share.addEventListener('click', function () {
    var url = writeUrl();
    var done = function () { els.status.textContent = 'Link copied. Send it to anyone and they will see this exact setting.'; };
    if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(url).then(done, function () { els.status.textContent = url; });
    else els.status.textContent = url;
  });

  els.add.addEventListener('click', async function () {
    var items = [];
    slots.forEach(function (s) { var c = state.sel[s.slot]; var p = c.on ? piece(c.pattern, s.slot) : null; if (p) p.items.forEach(function (it) { items.push({ id: it.id, quantity: state.qty }); }); });
    if (!items.length) return;
    var label = els.add.textContent; els.add.disabled = true; els.add.textContent = 'Adding…'; els.status.textContent = '';
    try {
      var res = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) });
      if (!res.ok) { var err = await res.json().catch(function () { return {}; }); throw new Error(err.description || err.message || 'Add failed'); }
      var ps = window.ParkShores || {};
      if (typeof ps.refreshCartDrawer === 'function' && typeof ps.openCartDrawer === 'function') { await ps.refreshCartDrawer(); ps.openCartDrawer(); }
      else { window.location.href = '/cart'; return; }
      els.status.textContent = 'Added ' + items.length + ' piece' + (items.length === 1 ? '' : 's') + ' × ' + state.qty + ' to your cart.';
    } catch (err) {
      els.status.textContent = 'Something went wrong adding those pieces: ' + err.message;
    } finally { els.add.textContent = label; els.add.disabled = false; }
  });

  fetch(root.dataset.src, { cache: 'no-cache' }).then(function (r) { return r.json(); }).then(function (d) { data = d; init(); })
    .catch(function () { els.rail.innerHTML = '<p class="herend-sms__loading">The pattern list could not be loaded. Please refresh, or browse <a href="/collections/herend">Herend dinnerware</a>.</p>'; });
})();
